module.exports = __webpack_public_path__ + "static/media/mentor.768e4d9c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/mentor.webp
// module id = 540
// module chunks = 4